export const Types = {
  VIDEO: 'video'
}
